import React, { useContext } from "react";

import { AppRoutes } from "../../constants/appRoutes";
import { AuthContext } from "../../context/contextProvider";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Navigate } from "react-router-dom";
import OilBarrelIcon from "@mui/icons-material/OilBarrel";
import WorkOrdersPage from "../workOrders/WorkOrdersPage";

const breadcrumbs = [
  {
    IconComponent: DashboardIcon,
    title: "Dashboard",
    to: AppRoutes.dashboard,
  },
  {
    IconComponent: OilBarrelIcon,
    title: "Direct Drops",
  },
];

const DirectDropsActivePage = (props) => {
  const { branchModules } = useContext(AuthContext);

  if (!branchModules?.directDrops)
    return (
      <Navigate
        to={{
          pathname: AppRoutes.forbidden,
        }}
      />
    );

  return (
    <WorkOrdersPage
      breadcrumbs={breadcrumbs}
      directDrops
      title="Direct Drops - Active"
    />
  );
};

export default DirectDropsActivePage;
